import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { VerifyUserComponent } from './pages/verify-user/verify-user.component';

const routes: Routes = [
  { path: ':token', pathMatch: 'full', component: VerifyUserComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})

export class AppRoutingModule { }
